import React from 'react';

import APaginationInline from '../../molecules/APaginationInline';

const PAGE_SIZE_OPTIONS = [25, 50, 100, 200];

interface TablePaginationFooterProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    pageSize: number;
    onPageSizeChange: (size: number) => void;
    rangeStart: number;
    rangeEnd: number;
    totalRows: number;
}

/**
 * AF-3418: rodapé de paginação no mesmo padrão da tela de monitoramento PLD
 * (APaginationInline + contagem de registros).
 *
 * Além da navegação, a paginação corta o custo de renderização: antes a tabela montava
 * todas as linhas do lote de uma vez.
 */
const TablePaginationFooter: React.FC<TablePaginationFooterProps> = ({
    page,
    totalPages,
    onPageChange,
    pageSize,
    onPageSizeChange,
    rangeStart,
    rangeEnd,
    totalRows,
}) => {
    if (totalRows === 0) return null;

    return (
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-3">
                <label className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                    Itens por página
                    {/*
                      appearance-none é obrigatório: a regra global `select { background-image: ... }`
                      em molecules/APagination.css adiciona uma seta a todo select do app sem
                      suprimir a nativa. Sem appearance-none aparecem duas setas.
                    */}
                    <select
                        value={pageSize}
                        onChange={(event) => onPageSizeChange(Number(event.target.value))}
                        className="h-8 appearance-none rounded-md border border-gray-300 bg-white pl-2 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-700 dark:text-gray-100"
                        aria-label="Itens por página"
                    >
                        {PAGE_SIZE_OPTIONS.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                </label>

                <span className="text-sm text-gray-600 dark:text-gray-400">
                    {rangeStart.toLocaleString('pt-BR')}–{rangeEnd.toLocaleString('pt-BR')} de{' '}
                    {totalRows.toLocaleString('pt-BR')}
                </span>
            </div>

            {totalPages > 1 && (
                <APaginationInline
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={onPageChange}
                />
            )}
        </div>
    );
};

export default TablePaginationFooter;
